import { CustomNode } from '../../../types';
import { sendWhatsAppIcon } from '../../../icons';

const DEFAULT_ICON = sendWhatsAppIcon;

export const sendWhatsAppConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
